import { render, staticRenderFns } from "./flowFormConfig.vue?vue&type=template&id=948c216c&scoped=true&"
import script from "./flowFormConfig.vue?vue&type=script&lang=js&"
export * from "./flowFormConfig.vue?vue&type=script&lang=js&"
import style0 from "./flowFormConfig.vue?vue&type=style&index=0&id=948c216c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948c216c",
  null
  
)

export default component.exports